import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, ToastController } from 'ionic-angular';
import { Events, Platform } from 'ionic-angular';
import 'rxjs/add/operator/timeout';
// import { Http } from '@angular/http';

@Injectable()
export class ItineraireProvider {
  /* ######################################################################
     App Version
  ###################################################################### */
  public version:string = "0.4.2";

  public currentPath:any = [];
  public histid:number;
  public currentPathTTA:number = 0;
  // public apiUrl: string = './assets/itineraire.json';
  // public apiUrl: string = 'https://dzt.local/api/dzt-getpath.php?action=getpath&infos=true';
  // public apiUrlRating: string = 'https://dzt.local/api/dzt-rating.php';
  public apiUrl: string = 'https://www.dzairtransport.com/api/dzt-getpath.php?action=getpath&infos=true';
  public apiUrlRating: string = 'https://www.dzairtransport.com/api/dzt-rating.php';

  constructor(public http: HttpClient, private alertCtrl: AlertController, private toastCtrl: ToastController, public events: Events, public plt: Platform) {
    // console.log('Hello ItineraireProvider Provider');
    window.localStorage.setItem("version",this.version);
    this.apiUrl = this.apiUrl + '&requester=dzt-app-' + window.localStorage.getItem("version");
  }

  /* ######################################################################
     Affichage d'un message
  ###################################################################### */
  private presentAlert(subTitle, title?) {
    let alert = this.alertCtrl.create({
      title: (title?title:''),
      subTitle: subTitle,
      buttons: ['Ok']
    });
    alert.present();
  }
  public getCurrentTTA() {
    // return this.currentPath[this.currentPath.length()].stations[this.currentPath[this.currentPath.length()].stations.length()].tta;
    // return this.currentPath[1].stations.length;
  }

  /* ######################################################################
     Envoi des avis
  ###################################################################### */
  public sendRating(rating:number, name:string = '', email:string = '', message:string = '', histid:number = this.histid) {
    let data = JSON.stringify({
      rating: rating,
      histid: histid,
      name: name,
      email: email,
      message: message,
      platforms: this.plt.platforms(),
      requester: 'dzt-app-' + localStorage.getItem("version")
    });
    this.http.post(this.apiUrlRating, data)
    .timeout(8000)
    .subscribe(data =>
    {
      if ((data['status']) && (data['status']=="fail")) {
      } else {
      }
      return data;
    }, err => {
      console.log(err.message);
    }, () => {
    });
  }

  /* ######################################################################
     Recherche d'itineraire avec affichage du Loading
  ###################################################################### */
  public getPath(slug_start:string, slug_end:string)/*: Promise<Object>*/ {
    // console.log("Getting path from :");
    // console.log(this.apiUrl + '&s_start=' + encodeURI(s_start) + '&s_finish=' + encodeURI(s_finish));

    // Presentation du Loading
    let toast = this.toastCtrl.create({
      message: 'Chargement',
      duration: 10000,
      position: 'top'
    });
    toast.onDidDismiss(() => {
      // console.log('Dismissed toast');
    });
    toast.present();

    this.currentPath=[];
    // let cachedData:any = localStorage.getItem(slug_start + '/' + slug_end);
    // if (cachedData){
    //   console.log(JSON.parse(cachedData));
    // }

    var posUrlAdd:string = "";
    var currTimestamp:number = Math.round(new Date().getTime()/1000);
    // Ajouter la position si la date de mise a jour < 1 heure (3600 secondes)
    if ( (currTimestamp - Number(localStorage.getItem("myPos.upd"))) < 3600) {
      posUrlAdd = "&lat=" + localStorage.getItem("myPos.lat") + "&lon=" + localStorage.getItem("myPos.lon") + "&acc=" + localStorage.getItem("myPos.acc");
    }
    this.http.get(this.apiUrl + '&slug_start=' + encodeURI(slug_start) + '&slug_end=' + encodeURI(slug_end) + '&platforms=' + JSON.stringify(this.plt.platforms()) + posUrlAdd)
    .timeout(8000)
    .subscribe(data =>
    {
      if ((data['status']) && (data['status']=="fail")) {
        console.log("Error getting path: \r\n" + data['message']);
        toast.dismiss();
        this.events.publish('itineraire:error');
        this.presentAlert(data['message']);
      } else {
        this.currentPath = data['path'];
        this.histid = data['histid'];
        this.currentPathTTA = this.currentPath[this.currentPath.length-1].stations[this.currentPath[this.currentPath.length-1].stations.length-1].tta;
        // console.log(this.currentPath[this.currentPath.length-1].stations[this.currentPath[this.currentPath.length-1].stations.length-1].tta);
        // console.log(this.currentPath);

        // Ajout de l'element FOLDED pour cacher les stations
        this.currentPath.forEach(function(segment,index,arr) {
          arr[index].folded=true;
        }, this);
        toast.dismiss();
        this.events.publish('itineraire:received');
        // localStorage.setItem(slug_start + '/' + slug_end, JSON.stringify(data));
      }
      return data;
    }, err => {
      console.log(err.message);
      this.presentAlert("Veuillez vérifier votre connection internet.", "Connection");
      this.events.publish('itineraire:error');
      toast.dismiss();
    }, () => {
      // console.log("HTTP request done !");
      // toast.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/itineraire/itineraire.ts